import 'velocity-animate';

var alertServiceComponent   = '.js-alert-service',
    resultComponent         = '.js-result',
    emailField              = '.js-email-field',
    nameField               = '.js-name-field',
    emailSubmitButton       = '.js-email-submit';

// On email form submit
$('body').on('click', alertServiceComponent + ' ' + emailSubmitButton, function(){

    // Check if email is valid
    if($(emailField).valid()){

        // Get email field value
        var emailFieldValue = $(emailField).val();

        // Post email to API
        postEmail(emailFieldValue);
    }

    return false;

});

function postEmail(email){

    // Serialize select
    var serializedForm = $(emailField).serialize();

    // Add sitecore controller (from data attribute)
    serializedForm += '&scController=' + $(emailSubmitButton).data('sccontroller');

    // Add sitecore action (from data attribute)
    serializedForm += '&scAction=' + $(emailSubmitButton).data('scaction');

    // Ajax post
    $.ajax({    
        type: 'POST',  
        url: window.location,  
        data: serializedForm,
        success: function(data){
            
            // Remove emailSubmitButton
            hideEmailSubmitButton();

            if(data !== ""){

                // Reset current name field
                resetName();

                // Set name
                setName(data.FullName);

                // Reset current checkboxes
                resetCheckboxes();

                // Loop though result and set checkboxes
                setCheckboxes(data.SubscribedCategories);
            }

            // Slidedown result component
            showResultComponent();

        },
        error: function(data) { 
            console.error('Something went wrong');
        }
    });
}

function hideEmailSubmitButton(){
    $(emailSubmitButton).velocity('slideUp', { duration: 200 }).removeClass('is-active');
}

function resetName(){
    $(nameField).val('');
}

function setName(name){
    $(nameField).val(name);
}

function resetCheckboxes(){
    $(resultComponent).find('input[type="checkbox"]').each(function( index ) {
        $(this).prop('checked', false);
    });
}

function setCheckboxes(categories){
    categories.forEach(function(category) {
        var test = $(resultComponent).find('[data-val=\"' + category.InternalName + '\"]');
        test.prop('checked', true);
    });
}

function showResultComponent(){
    $(resultComponent).velocity('slideDown', { duration: 200 }).addClass('is-active');
}
